import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface AdminPointOfInterestTypeDto {
	id: string;
	name: string;
	description: string | null;
	category: string | null;
	travelTimeModifier: number;
	defaultAttitude: string | null;
	defaultLootProfile: string | null;
	encounterBias: string | null;
	colorToken: string | null;
	imageAssetId: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface AdminPointOfInterestTypesListResponse {
	pointOfInterestTypes: AdminPointOfInterestTypeDto[];
}

export interface AdminPointOfInterestTypeGetResponse {
	pointOfInterestType: AdminPointOfInterestTypeDto;
}

export interface AdminPointOfInterestTypeCreateRequest {
	id?: string | null;
	name: string;
	description?: string | null;
	category?: string | null;
	travelTimeModifier?: number | null;
	defaultAttitude?: string | null;
	defaultLootProfile?: string | null;
	encounterBias?: string | null;
	colorToken?: string | null;
	imageAssetId?: string | null;
}

export interface AdminPointOfInterestTypeUpdateRequest {
	name?: string | null;
	description?: string | null;
	category?: string | null;
	travelTimeModifier?: number | null;
	defaultAttitude?: string | null;
	defaultLootProfile?: string | null;
	encounterBias?: string | null;
	colorToken?: string | null;
	imageAssetId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class AdminPointOfInterestTypesService {
	constructor(private readonly http: HttpClient) {}

	list(): Observable<AdminPointOfInterestTypesListResponse> {
		return this.http.get<AdminPointOfInterestTypesListResponse>(
			`${environment.api.baseUrl}/v1/admin/point-of-interest-types`
		);
	}

	get(id: string): Observable<AdminPointOfInterestTypeGetResponse> {
		return this.http.get<AdminPointOfInterestTypeGetResponse>(
			`${environment.api.baseUrl}/v1/admin/point-of-interest-types/${id}`
		);
	}

	create(request: AdminPointOfInterestTypeCreateRequest): Observable<AdminPointOfInterestTypeGetResponse> {
		return this.http.post<AdminPointOfInterestTypeGetResponse>(
			`${environment.api.baseUrl}/v1/admin/point-of-interest-types`,
			request
		);
	}

	update(id: string, request: AdminPointOfInterestTypeUpdateRequest): Observable<AdminPointOfInterestTypeGetResponse> {
		return this.http.put<AdminPointOfInterestTypeGetResponse>(
			`${environment.api.baseUrl}/v1/admin/point-of-interest-types/${id}`,
			request
		);
	}

	delete(id: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/admin/point-of-interest-types/${id}`);
	}
}
